var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card-goal"},[_c('h4',{staticClass:"card-goal-text"},[_vm._v(" "+_vm._s(_vm.$t('comp.card.goal.title'))+" ")]),_c('p',{staticClass:"card-goal-text",domProps:{"innerHTML":_vm._s(_vm.goalHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }